// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { RecordDataCommandParams, IRecordDataCommandParams } from "./DeviceCommands.RecordDataCommandParams.gen";
import { Device, IDevice } from "./Device.gen";

export interface IRecordDataCommand {
	description: string | undefined;

	commandParamsJson: IRecordDataCommandParams | undefined;

	device: IDevice | undefined;

	id: string | undefined;

	deviceId: string | undefined;

	dateCreated: string | undefined;

	dateSentToDevice: string | undefined;

	dateCompleted: string | undefined;

	deviceDidSucceed: boolean | undefined;

	deviceResponse: string | undefined;

	$type?: string | undefined;
}
export class RecordDataCommand {
	constructor(data?: IRecordDataCommand) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.commandParamsJson) { this.commandParamsJson = new RecordDataCommandParams(data.commandParamsJson); }
		if (data.device) { this.device = new Device(data.device); }
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
		if (data.dateSentToDevice) { this.dateSentToDevice = new Date(data.dateSentToDevice); }
		if (data.dateCompleted) { this.dateCompleted = new Date(data.dateCompleted); }
	}

	description: string | undefined;

	commandParamsJson: RecordDataCommandParams | undefined;

	device: Device | undefined;

	id: string | undefined;

	deviceId: string | undefined;

	dateCreated: Date | undefined = new Date();

	dateSentToDevice: Date | undefined;

	dateCompleted: Date | undefined;

	deviceDidSucceed: boolean | undefined;

	deviceResponse: string | undefined;

	static $type: string = "CoreApi.Models.DeviceCommands.RecordDataCommand, ";
	$type?: string | undefined = RecordDataCommand.$type;
}

